import React, { Component } from 'react'
import { fonts } from 'app/common/typography'
import { colors } from 'shared/assets/styles'
import { Chevron } from 'app/assets/icons'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import type { SelectOption } from 'app/common/forms'
import { media } from 'app/assets/styles'

type Props = {
    width?: string,
    margin?: string,
    disabled?: boolean,
    selectOptions: Array<SelectOption>,
    defaultValue?: string,
    placeholderKey?: string,
    background?: string,
    borderColor?: string,
    handleChange: string => void,
    chevronColor?: string,
    color?: string,
    className?: string,
    intl: IntlShape
}

type State = {
    value: string
}

class DropdownSelectComponent extends Component<Props, State> {
    constructor(props: Props) {
        super()
        this.state = {
            value: props.defaultValue || ''
        }
    }

    applySelectedItem = (e: SyntheticEvent<any>) => {
        const { handleChange } = this.props
        const value = e.currentTarget.value
        if (value !== '-1') {
            handleChange(value)
            this.setState({ value })
        }
    }

    render() {
        const {
            width,
            margin,
            selectOptions,
            background,
            borderColor,
            placeholderKey,
            chevronColor = colors.text,
            className,
            intl,
            disabled,
            color
        } = this.props

        return (
            <Dropdown
                className={className}
                background={background}
                borderColor={borderColor}
                width={width}>
                <Select
                    margin={margin}
                    color={color}
                    disabled={disabled}
                    className={className}
                    value={this.state.value}
                    onChange={e => this.applySelectedItem(e)}>
                    {placeholderKey && (
                        <Option value="-1" hidden>
                            {intl.formatMessage({ id: placeholderKey })}
                        </Option>
                    )}
                    {selectOptions.map((so, index) => (
                        <Option
                            key={index}
                            value={so.code}
                            disabled={so.disabled}>
                            {so.label}
                        </Option>
                    ))}
                </Select>
                <ChevronContainer>
                    <Chevron direction="down" color={chevronColor} />
                </ChevronContainer>
            </Dropdown>
        )
    }
}

const Dropdown = styled.div`
    position: relative;
    width: ${({ width }) => width || '350px'};
    z-index: 0;
    &.categories {
        width: 200px;
    }
    background-color: ${props =>
        props.background ? props.background : 'transparent'};
    border-radius: 10px;
    ${props =>
        props.borderColor ? `border: 1px solid ${props.borderColor};` : null}
    ${media.medium`
        width: ${({ width }) => width || '400px'};
    `}
`

const Select = styled.select`
    text-transform: uppercase;
    outline: 0;
    margin: ${({ margin }) => margin || 'auto'};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    border: none;
    width: 100%;
    -webkit-appearance: none;
    font-family: ${fonts.flameRegular};
    color: ${props => (props.color ? props.color : colors.text)};
    font-size: 16px;
    padding: 10px 24px;
    &.categories {
        text-transform: none;
        font-family: ${fonts.roboto};
        padding-left: 0;
    }

    &.schoolType {
        text-transform: none;
        font-family: ${fonts.roboto};
        padding-left: 10px;
    }

    background: none;

    /* to hide select arrow under IE */
    &::-ms-expand {
        display: none;
    }
`

const Option = styled.option`
    font-family: ${fonts.roboto};
    background: white;
    -webkit-appearance: none;
`

const ChevronContainer = styled.span`
    position: absolute;
    right: 15px;
    z-index: -1;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0;
`

export const DropdownSelect = injectIntl(DropdownSelectComponent)
